import React from 'react';
import i18n from '../i18n/config';
import { BLOG_ROUTES, type Locale } from '../constants/blogRoutes';

const getCurrentLocale = (): Locale => {
  const locale = (i18n.locale || document.documentElement.lang || 'lv') as Locale;
  return ['en', 'lv', 'ru'].includes(locale) ? locale : 'lv';
};

const Logo: React.FC = () => {
  const logoTitle = i18n.t('header.logo.title');
  const logoSubtitle = i18n.t('header.logo.subtitle');
  const tldIndex = logoTitle.toLowerCase().lastIndexOf('.lv');
  const brandName = tldIndex > 0 ? logoTitle.slice(0, tldIndex) : logoTitle;
  const tld = tldIndex > 0 ? logoTitle.slice(tldIndex) : '';

  const locale = getCurrentLocale();
  const brokerSlug = BLOG_ROUTES.find((blog) => blog.id === 'independent_broker')?.slug[locale];
  const brokerHref = brokerSlug ? `/${locale}/blogs/${brokerSlug}` : '/';

  return (
    <div className="inline-flex flex-col">
      <a
        href="/"
        className="group no-underline transition-opacity duration-200 hover:opacity-85"
        aria-label={logoTitle}
      >
        <span className="font-display whitespace-nowrap text-[1.625rem] font-bold leading-none sm:text-[1.875rem]">
          <span className="text-primary-500">{brandName}</span>
          {tld && <span className="text-accent-500">{tld}</span>}
        </span>
      </a>
      <a
        href={brokerHref}
        className="mt-0.5 whitespace-nowrap text-[0.6875rem] font-medium uppercase tracking-wide text-neutral-500 no-underline transition-colors hover:text-primary-500 sm:text-xs"
      >
        {logoSubtitle}
      </a>
    </div>
  );
};

export default Logo;
